import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/modules/admin/services/admin.service';
import { QuotaDetail } from 'app/modules/domain/models/quotaDetails';
import { AuthService } from 'app/modules/auth/services/auth.service';
import { EditUserQuotaComponent } from '../edit-user-quota/edit-user-quota.component';
import { MdDialog } from '@angular/material';
import { RoleGuardService } from 'app/modules/auth/services/role.guard';

@Component({
  selector: 'app-quota-info',
  templateUrl: './quota-info.component.html',
  styleUrls: ['./quota-info.component.scss']
})
export class QuotaInfoComponent implements OnInit {
  public ownQuota: number;
  public isAdmin = false;
  private companyId: string;
  private userId: string;

  constructor(private adminService: AdminService,
              private authService: AuthService,
              private roleGuardService: RoleGuardService,
              public dialog: MdDialog) { }

  ngOnInit() {
    const token = this.authService.getDecodedJwtToken();
    this.companyId = token.CompanyId;
    this.userId = token.sub;

    this.isAdmin = this.roleGuardService.isAuthorized(['Admin']);

    this.getOwnQuota();
  }

  public openDialog() {
    const dialogRef = this.dialog.open(EditUserQuotaComponent, {
      width: '450px',
      data: {
        companyId: this.companyId,
        userQuota: this.ownQuota
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.adminService.updateUserQuota(this.companyId, this.userId, result.userQuota).subscribe(() => {
          this.ownQuota = result.userQuota;
        });
      }
    });
  }

  private getOwnQuota(): void {
    this.adminService.getOwnQuota()
      .subscribe((quota: QuotaDetail) => {
        this.ownQuota = quota.totalQuota;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/myaccount/components/quota-info/quota-info.component.ts